import React from 'react'
import { Chart } from 'react-google-charts'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import { ProgressColors } from '../section-header/styles'

interface Props {
  position10?: number
  position9?: number
  position8?: number
  position7?: number
  position6?: number
  position5?: number
  position4?: number
  position3?: number
  position2?: number
  position1?: number
}

function BarColumnChart({
  position1 = 0,
  position10 = 0,
  position2 = 0,
  position3 = 0,
  position4 = 0,
  position5 = 0,
  position6 = 0,
  position7 = 0,
  position8 = 0,
  position9 = 0
}: Props) {
  const { t } = useTranslation()
  const data = [
    [
      '',
      { role: 'data' },
      { role: 'style' },
      { role: 'annotation' },
      { role: 'tooltip' }
    ],
    ['10', position10, ProgressColors.HIGH, position10, position10],
    ['9', position9, ProgressColors.HIGH, position9, position9],
    ['8', position8, ProgressColors.MEDIUM, position8, position8],
    ['7', position7, ProgressColors.MEDIUM, position7, position7],
    ['6', position6, ProgressColors.LOW, position6, position6],
    ['5', position5, ProgressColors.LOW, position5, position5],
    ['4', position4, ProgressColors.LOW, position4, position4],
    ['3', position3, ProgressColors.LOW, position3, position3],
    ['2', position2, ProgressColors.LOW, position2, position2],
    ['1', position1, ProgressColors.LOW, position1, position1]
  ]

  const options = {
    annotations: {
      alwaysOutside: true
    },
    hAxis: {
      minTextSpacing: 0,
      gridlines: {
        minSpacing: 0
      }
    },
    legend: 'none',
    minTextSpacing: 0,
    minValue: 0,
    title: t('common.nps.chart.score-per-rate'),
    vAxis: {
      gridlines: {
        count: 3
      }
    },
    textPosition: 'none'
  }

  return (
    <Chart
      chartType="ColumnChart"
      data={data}
      loader={<Spin />}
      options={options}
      width={300}
    />
  )
}

export default BarColumnChart
